import 'css-chunksrc/client/scenes/workloads/wbs/project/dateForm/dateTimeInput/styles.scss';export default {
  "dateTimeInput": "_dateTimeInput_x8vbf_1",
  "input": "_input_x8vbf_6",
  "placeholder": "_placeholder_x8vbf_22",
  "value": "_value_x8vbf_27",
  "calendarInput": "_calendarInput_x8vbf_32",
  "calendar": "_calendar_x8vbf_32",
  "timeList": "_timeList_x8vbf_48",
  "timeListWrapper": "_timeListWrapper_x8vbf_57",
  "time": "_time_x8vbf_48",
  "timeName": "_timeName_x8vbf_69",
  "invalid": "_invalid_x8vbf_75",
  "disabled": "_disabled_x8vbf_83"
};